import { AHText, Box } from "arkh";
import React from "react";
import { formatNumberValue } from "./formatNumber";
import { EmptyResult } from "../../components/EmptyResult";

import { colorForNumber } from "./colorForNumber";
import { NumberTaskUnit } from "./__generated__/WidgetTaskSingleNumberOccasionPage_taskNumber.graphql";

function SmallInProgressC(props: {
  unit: NumberTaskUnit;
  sum: number | null;
  goalLessThan: number | null;
  goalLargerThan: number | null;
}) {
  return (
    <Box spaceTop="small" spaceRight="medium">
      <AHText
        type="title"
        numberOfLines={1}
        adjustsFontSizeToFit
        minimumFontScale={0.6}
        color={colorForNumber(
          props.sum,
          props.goalLessThan,
          props.goalLargerThan
        )}
      >
        {props.sum === null ? (
          <EmptyResult />
        ) : (
          formatNumberValue(props.unit, props.sum)
        )}
      </AHText>
    </Box>
  );
}
export const SmallInProgress = React.memo(SmallInProgressC);
